var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$store.state.theme},[_c('div',{staticClass:"bg-body",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"ReservationConfirm,ReservationWait"}},[_c('router-view')],1),_c('Nav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }